import React from 'react';
import ContentPortfolioPage from "../../templates/PortfolioPage";
import Header from "../../components/header/HeaderOne";
import SideHeader from "../../components/SideHeader";
import FooterThree from "../../components/footer/FooterThree";

const PortfolioPage = () => {
    return (
        <div className={`main-wrapper`}>
            <Header/>
            <SideHeader mobile={true}/>
            <ContentPortfolioPage/>
            <FooterThree position={'fixed'}/>
        </div>

    );
};

export default PortfolioPage;